import { useContext } from 'react';
import { ApprovalContext } from '../context/approvalContext';
export function useApprovalContext() {
  return useContext(ApprovalContext);
}